import usePxContext from './usePxAuthContext';
import AuthModal from '../features/Visitor/components/Authentication/StandardAuthModal';
import styles from './RequireAuthentication.module.scss';
import useCurrentMetaverse from 'src/features/Dashboard/hooks/useCurrentMetaverse';

type Props = {
  overrideSSOs?: string[];
  children?: React.ReactNode;
};

export default function RequireMetaverseAuthentication({ overrideSSOs, children }: Props) {
  const { metaverse } = useCurrentMetaverse();
  const { isAuthenticated } = usePxContext();

  const logins = metaverse?.editorLogins ?? [];

  return isAuthenticated
    ? <>{children}</>
    : <AuthModal classes={{ modal: styles.modal }} open closable={false} logins={logins} />;
}
